<template>
  <Teleport to="body">
    <div class="howto-backdrop" @click.self="$emit('close')">
      <div class="howto guide help-menu" role="dialog" aria-modal="true" aria-label="Help">
        <button class="howto__close icon-button" aria-label="Close" @click="$emit('close')">×</button>
        <div class="howto__body">
          <h3>What do you need?</h3>
          <ul class="help-menu__list">
            <li v-for="item in items" :key="item.key">
              <button class="help-menu__item" @click="$emit('pick', item.key)">
                <span class="help-menu__name">{{ item.name }}</span>
                <span class="help-menu__sub">{{ item.sub }}</span>
              </button>
            </li>
          </ul>
        </div>
        <div class="howto__nav">
          <span class="howto__dots" />
          <button class="secondary howto__next" @click="$emit('close')">Close</button>
        </div>
      </div>
    </div>
  </Teleport>
</template>

<script>
import { ROLE_INFO, ROLES } from '@/engine/constants';

// The one help door. Three things behind it: the game, your own role, and
// the words. See src/help.js for why it lives in the header.
export default {
  name: 'HelpMenu',
  props: { role: { type: String, default: null } },
  emits: ['close', 'pick'],
  computed: {
    items() {
      const list = [];
      // The tutorial first: a practice day on a copy, nothing counts
      // (playtest 9). The old guide stays as the quick reference.
      if (this.role) {
        list.push({
          key: 'tutorial',
          name: `Tutorial: learn the ${ROLE_INFO[this.role].label}`,
          sub: 'A practice day on your own board, step by step. Nothing in it touches the game.',
        });
        if (this.role === 'science') {
          list.push({
            key: 'tutorial:machines',
            name: 'Tutorial: the machines',
            sub: 'The Kiln, the Still and the Crucible: how to crack a law and make a deep technology.',
          });
        }
        list.push({
          key: 'role',
          name: `The ${ROLE_INFO[this.role].label} at a glance`,
          sub: 'A short reference card for your board.',
        });
      } else {
        ROLES.forEach((r) => list.push({
          key: `tutorial:${r}`,
          name: `Tutorial: learn the ${ROLE_INFO[r].label}`,
          sub: ROLE_INFO[r].tagline,
        }));
      }
      list.push({ key: 'game', name: 'How this game works', sub: 'The round, the deck, how it ends.' });
      list.push({ key: 'victories', name: 'How we win', sub: 'Four ways; the first to land ends the campaign. Where we stand on each.' });
      list.push({ key: 'words', name: 'What the words mean', sub: 'Food, threat, the compass, units.' });
      return list;
    },
  },
};
</script>
